var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"edit-action-bar"},[_c('pss-button',{attrs:{"text":"删除试卷"},on:{"on-click":_vm.clickDeletePaperBtnHandler}}),_c('pss-button',{attrs:{"text":"返回"},on:{"on-click":_vm.clickCanelBtnHandler}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }